import { render, staticRenderFns } from "./video-page.vue?vue&type=template&id=12ebf546&lang=pug&"
import script from "./video-page.vue?vue&type=script&lang=js&"
export * from "./video-page.vue?vue&type=script&lang=js&"
import style0 from "./video-page.vue?vue&type=style&index=0&id=12ebf546&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports